import React, { CSSProperties, FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { RecentlyViewedItem } from '../../../../../../../generated/graphql';
import { IListingItemProps } from '../product-listing-component';
import styles from './brand-listing-item-component.module.scss';

export type BrandListingItemProps = IListingItemProps<RecentlyViewedItem>;

export const BrandListingItem: FunctionComponent<BrandListingItemProps> = (props: BrandListingItemProps) => {
  return (
    <div className={styles['listing-item-wrapper']}>
      <Link
        to={'/' + props.item.url.url}
        onClick={onClick}
        className={`${styles['listing-item-container']}`}
        style={{ '--tablet-width': props.tabletWidth ?? 'fit-content' } as CSSProperties}>
        {props.item.imageUrl && <img className={styles.image} src={props.item.imageUrl} alt={props.item.url.text}></img>}
        {!props.item.imageUrl && <span className={styles.name}>{props.item.id}</span>}
      </Link>
    </div>
  );

  function onClick() {
    props.onClickCallback && props.onClickCallback(props.item);
  }
};
